import PropTypes from 'prop-types';
import React from 'react';
import { Button, ButtonToolbar, Popover, PopoverBody } from 'reactstrap';

export default function ConfirmationPopover({
  content,
  handleConfirm,
  placement,
  id,
  children,
  className,
}) {
  const [isOpen, setIsOpen] = React.useState(false);

  const handleConfirmation = () => {
    setIsOpen(false);
    if (handleConfirm) handleConfirm();
  };

  return (
    <>
      <div id={`popover-${id}`} className={className}>
        {children}
      </div>
      <Popover
        placement={placement}
        isOpen={isOpen}
        target={`popover-${id}`}
        toggle={() => setIsOpen(!isOpen)}
        trigger="legacy"
      >
        <PopoverBody
          className="pt-2 pb-3 px-3 text-white"
          style={{ fontSize: 14 }}
        >
          <div className="mb-3">{content || 'Are you sure?'}</div>
          <ButtonToolbar>
            <Button
              onClick={() => handleConfirmation()}
              aria-label="Yes"
              color="primary"
              className="me-3"
              id="DgMGDwcHAgoGDQALBA0IAQ"
            >
              Yes
            </Button>
            <Button
              onClick={() => setIsOpen(false)}
              color="secondary"
              aria-label="No"
            >
              No
            </Button>
          </ButtonToolbar>
        </PopoverBody>
      </Popover>
    </>
  );
}

ConfirmationPopover.propTypes = {
  content: PropTypes.any,
  handleConfirm: PropTypes.func,
  placement: PropTypes.string,
  children: PropTypes.node.isRequired,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  className: PropTypes.string,
};
